import React, { Component } from 'react';

import styles from './Headline.css'

export default class Headline extends Component {
  render() {
    const { large, pageTitle, small, medium, grey, subtitle, center, orange } = this.props;

    let classes = [styles.headline];
    if (pageTitle) {
      classes.push(styles.pageTitle);
    }

    if (orange) {
      classes.push(styles.orange);
    }

    if (pageTitle) {
      classes.push(styles.center);
    }

    if (grey) {
      classes.push(styles.grey);
    }

    if (subtitle) {
      classes.push(styles.subtitle);
    }

    if (small) {
      classes.push(styles.small);
    }

    if (center) {
      classes.push(styles.center);
    }

    if (large) {
      return (
        <h1 className={classes.join(' ')}>{this.props.children}</h1>
      );
    }

    if (small) {
      return (
        <h5 className={classes.join(' ')}>{this.props.children}</h5>
      );
    }

    if (medium) {
      return (
        <h4 className={classes.join(' ')}>{this.props.children}</h4>
      );
    }

    return (
      <h2 className={classes.join(' ')}>{this.props.children}</h2>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Headline/Headline.js